import { useEffect, useRef } from 'react';

import { useAppSelector } from '@src/core/hooks';
import { DirectLinkType } from '@src/domains/direct-links';
import { buyerSelector, setupAuthOngoingSelector } from '@src/features/customers';
import { useTransactable } from '@src/features/transactables';

import { trackCheckoutStarted } from '../checkoutTracking';
import { useCheckoutEventProps } from './useCheckoutEventProps';

export const useCheckoutStartedEvent = () => {
  const props = useCheckoutEventProps();
  const transactable = useTransactable();
  const [, logged] = useAppSelector(buyerSelector);
  const setupAuthOngoing = useAppSelector(setupAuthOngoingSelector);
  const trackedRef = useRef(false);

  // The checkout announces itself once it knows what it is charging, which is the product for every
  // shape but one: a payment planne link carries an amount and nothing else, so waiting for a
  // product would leave it out of the funnel. A sale or cart link does get products — later than the
  // link itself hydrates — and has to wait for them, or the funnel starts empty.
  const isPaymentLink = transactable.directLink?.type === DirectLinkType.Payment;
  const knowsThePurchase = props.products.length > 0 || isPaymentLink;

  useEffect(() => {
    // The session is restored asynchronously: firing before it settles would report a returning
    // buyer as logged out.
    if (trackedRef.current || !knowsThePurchase || setupAuthOngoing) {
      return;
    }

    trackedRef.current = true;
    trackCheckoutStarted(props, { isLoggedIn: Boolean(logged) });
  }, [knowsThePurchase, logged, props, setupAuthOngoing]);
};

export default useCheckoutStartedEvent;
